import React from "react";
import {
  Container,
  Header,
  Title,
  ToggleContainer,
  Button,
  ButtonText,
  TotalSum
} from "./styled";

import { LineChart } from '@mui/x-charts/LineChart';
import Popper from "@mui/material/Popper";
import { styled } from "@mui/material/styles";

import LineChartCard from "../LineChart";
import BarChartCard from "../BarChart";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { theme } from "ui/theme-color";


export default function ChartCard({ title, children, data, totals }) {

  const [activeToggle, setActiveToggle] = React.useState('cumulativo');

  function formatNumber(num) {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
    }

    if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
    }

    return num?.toString();
  }

  return (
    <Container>
      <Header>
        <Title>{title}</Title>
        <HelpOutlineOutlinedIcon fontSize="10px" sx={{ color: theme.palette.colors.text }} />

        <TotalSum>{formatNumber(totals)}</TotalSum>
      </Header>

      <div style={{ width: "calc(100% - 54px)", height: 1, backgroundColor: '#E5E5E5', margin: "20px auto 0", }} />

      <ToggleContainer>
        <Button active={activeToggle === 'cumulativo'} onClick={() => setActiveToggle('cumulativo')}>
          <ButtonText>
            Cumulativo
          </ButtonText>
        </Button>

        <Button active={activeToggle === 'diario'} onClick={() => setActiveToggle('diario')}>
          <ButtonText >
            Diário
          </ButtonText>
        </Button>
      </ToggleContainer>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#FF00D6" />
              <stop offset="10%" stopColor="#CF07D5" />
              <stop offset="24%" stopColor="#9311D4" />
              <stop offset="42%" stopColor="#6419D3" />
              <stop offset="62%" stopColor="#431FD3" />
              <stop offset="84%" stopColor="#2E22D3" />
              <stop offset="100%" stopColor="#2724D3" />
            </linearGradient>
          </defs>
        </svg>

        {activeToggle === "cumulativo" ? <LineChartCard data={data?.monthly} /> : <BarChartCard data={data?.daily} />}

      </div>
    </Container>
  );
}


